import { useReverses } from 'hooks/reverses'

import { Flex, Text } from "@chakra-ui/react";

import BasicTable from '../BasicTable'
import Loading from 'components/Loading/Loading'

const columns = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Nome da Unidade",
    accessor: "partner_place.name",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Cadastrado em",
    accessor: "created_at",
  },
]

const ReversesTable = () => {
  const { isLoading, isFetching, reverses } = useReverses()

  if(isLoading || isFetching)
    return (
      <>
        { 
          <BasicTable 
            isLoading={true} 
            tableData={[{},{},{},{},{},{},{},{}]} 
            columnsData={columns} 
            route="coletas" 
          /> 
        }
      </>
    )

  if(reverses.length === 0)
    return (
      <Flex
        justifyContent="center"  
        alignItems="center"
        w="100%"
        h="100%"
        pl="22px"
        pr="22px"
      >
        <Text>
          Não foram encontradas coletas cadastradas
        </Text>
      </Flex>
    )

  return (
    <>
      { reverses.length > 0 && <BasicTable tableData={reverses} columnsData={columns} route="coletas" /> }
    </>
  )
}

export default ReversesTable